<template>
  <!-- 右侧浮动图标组 -->
  <div >
    <transition id="Icon_group" name="el-zoom-in-center">
      <div class="Icon_group" v-if="isDisFloat">
        <div class="Icon_item">
          <a href="tel:400-838-0148"
            ><img
              src="../assets/home/dianhua@3x.png"
              
          /></a>
        </div>
        <div class="Icon_item">
          <img
            @mouseover="isShowWXrcode = true"
            @mouseout="isShowWXrcode = false"
            src="../assets/home/weixin@3x.png"
           
          />
          <img
            v-if="isShowWXrcode"
            style="position: absolute; width: 143px; left: -164px; top: 54px"
            src="../assets/home/wxRode1.jpg"
            alt=""
          />
        </div>
        <div class="Icon_item" @click="backtop">
          <img src="../assets/home/top@3x.png" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowWXrcode: false, //是否悬浮显示微信二维码
      isDisFloat: false,
    };
  },
  methods: {
    //回到顶部
    backtop() {
      // document.documentElement.scrollTop = 0;
      // document.body.scrollTop = 0;
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },
    //滚动监听方法
    handleScroll() {
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 500 ? (this.isDisFloat = true) : (this.isDisFloat = false);
    },
  },
  mounted() {
    //添加滚动监听
    window.addEventListener("scroll", this.handleScroll);


  },
};
</script>

<style>
</style>